<template>
  <!-- VER PDF -->
  <v-dialog v-model="dialogReasignar.estatus" max-width="400px" persistent>
    <v-card>
    		<v-card-title></v-card-title>
    		<v-card-text class="black--text text-center" >
    		Selecciona una opción para la reasignación
    			<br/>
    			<span v-if="esMasivo" class="caption grey--text">
    				{{ listaProspectos.length }} contacto{{ listaProspectos.length === 1 ? '' : 's' }} seleccionado{{ listaProspectos.length === 1 ? '' : 's' }}
    			</span>
    			<span v-if="cantidadSinFolio" class="caption d-block mt-1">
    				{{ cantidadSinFolio }} sin folio: se generará y se asignará a la vendedora
    			</span>
    			<br/>
    			<br/>

			    <v-autocomplete
	          filled
	          dense
	          clearable
	          v-model="vendedoraUnica"
	          :items="vendedorasFiltradas"
	          label="Selecciona vendedora"
	          hide-details
	          item-text="nombre_plantel"
	          item-value="iderp"
	          return-object
	        >
	        </v-autocomplete>
    		</v-card-text>
    		<v-card-actions>
    			<v-btn 	
    				color="grey" 
    				icon 
    				dark 
    				small 
    				@click="dialogReasignar.estatus = false"
    				absolute
    				top
    				right
    			>
    				<v-icon>mdi-close</v-icon>
    			</v-btn>
    			<v-spacer></v-spacer>
    			<v-btn color="green" block large class="text-capitalize" dark  @click="iniciarReasignacion( )">Sí, seguro</v-btn>
    		</v-card-actions>
    	</v-card>
	  <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>
  </v-dialog>
</template>

<script>
	import axios from 'axios';

	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'


	export default {

		components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],

		props:{
			dialogReasignar: { type: Object, required: true },
			alumno: { default: null },
			wha: { default: null },
			chat: { default: null },
			/** Array opcional para reasignación masiva; si viene vacío usa [chat] */
			chats: { type: Array, default: null },
			/** 1 = INBI (sin FAST), 2 = FAST. Sin valor = todas */
			escuela: { default: null },
			/** Personas extra a mostrar al reasignar (ej. admin). { iderp, nombre, nombre_plantel? } */
			extrasReasignacion: { type: Array, default: () => [] },
		},

		data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      cargar: false,

      vendedoras:[],
      vendedoraUnica: null,

		}),

		computed:{
			listaProspectos () {
				if (Array.isArray(this.chats) && this.chats.length) {
					return this.chats
				}
				return this.chat ? [this.chat] : []
			},
			esMasivo () {
				return this.listaProspectos.length > 1
			},
			cantidadSinFolio () {
				return this.listaProspectos.filter((c) => c && !c.idprospectos && !c.folio).length
			},
			vendedorasFiltradas () {
				const lista = Array.isArray(this.vendedoras) ? this.vendedoras : []
				const extrasIds = {}
				;(this.extrasReasignacion || []).forEach((e) => {
					const id = Number(e && e.iderp)
					if (id > 0) extrasIds[id] = true
				})
				const escuela = Number(this.escuela)
				if (escuela !== 1 && escuela !== 2) return lista

				return lista.filter((persona) => {
					const id = Number(persona && persona.iderp)
					if (id > 0 && extrasIds[id]) return true
					const texto = String(
						(persona && (persona.plantel || persona.nombre_plantel || persona.nombre)) || ''
					)
					const esFast = /FAST/i.test(texto)
					return escuela === 2 ? esFast : !esFast
				})
			},
		},

		created(){

			this.getVendedorasCRM( )

		},

		methods: {
			initialize () {
				this.cargar = true
				this.usuarios = []
				return this.$http.get('whatsapp.usuarios').then(response=>{
					this.usuarios = response.data
					this.cargar      = false
				}).catch( error =>{
					this.validarError( error.response.data.message )
				}).finally( () => { this.cargar = false })
			},

			getVendedorasCRM () {
      	this.cargar = true
        this.vendedoras = []
        return this.$http.get('vendedoras.list').then(response=>{
        	this.vendedoras = response.data
			this.vendedoras = this.vendedoras.filter((persona, index, self) =>
				index === self.findIndex((p) => p.nombre_plantel === persona.nombre_plantel)
			);
			this.inyectarExtrasReasignacion()
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      inyectarExtrasReasignacion () {
      	const extras = Array.isArray(this.extrasReasignacion) ? this.extrasReasignacion : []
      	if (!extras.length) return
      	if (!Array.isArray(this.vendedoras)) this.vendedoras = []
      	extras.forEach((extra) => {
      		const id = Number(extra && extra.iderp)
      		if (!id) return
      		const yaEsta = this.vendedoras.some((v) => Number(v.iderp) === id)
      		if (yaEsta) return
      		const nombre = (extra.nombre_plantel || extra.nombre || ('Usuario ' + id))
      		this.vendedoras.unshift({
      			iderp: id,
      			nombre: extra.nombre || nombre,
      			nombre_plantel: nombre,
      			plantel: extra.plantel || '',
      			escuela: this.escuela,
      		})
      	})
      },

      iniciarReasignacion(){
      	const lista = this.listaProspectos
      	if (!lista.length) {
      		return this.validarError('No hay chats para reasignar')
      	}
      	if (!this.vendedoraUnica) {
      		return this.validarError('Selecciona una vendedora')
      	}

      	const sinWhatsapp = lista.filter((c) => !c || (!c.idprospectos && !c.usuario))
      	if (sinWhatsapp.length) {
      		return this.validarError('Hay chats sin WhatsApp para generar el folio. Desmárcalos e inténtalo de nuevo.')
      	}

      	const payload = {
      		vendedora            : this.vendedora,
					prospectosAReasignar : lista,
					opReasigancion       : 2,
					vendedoraUnica       : this.vendedoraUnica,
					escuela              : this.escuela,
      	}

      	this.cargar = true
        
        return this.$http.post('reasignar.prospectos.masivo', payload ).then(response=>{


        	this.dialogReasignar.estatus = false
	      	this.prospectosAReasignar = []

        	const idVendedora = this.vendedoraUnica && (this.vendedoraUnica.iderp || this.vendedoraUnica.id_usuario)
        	const nombreVendedora = this.vendedoraUnica && (this.vendedoraUnica.nombre_plantel || this.vendedoraUnica.nombre)
        	const primerChat = lista[0]

        	const prospectosCreados = (response.data && response.data.prospectos) || []

        	this.$emit('reasignado', {
        		usuario: primerChat && primerChat.usuario,
        		idprospectos: primerChat && primerChat.idprospectos,
        		usuarios: lista.map((c) => c.usuario).filter(Boolean),
        		chats: lista,
        		prospectos: prospectosCreados,
        		usuario_asignado: idVendedora,
        		nombre_vendedora: nombreVendedora,
        		vendedora: this.vendedoraUnica,
        		masivo: lista.length > 1,
        	})

	      	this.vendedoraUnica = null

        	this.validarSuccess(
        		lista.length > 1
        			? `${lista.length} contactos asignados correctamente`
        			: 'Datos reasignados correctamente'
        	)
        	this.dialogAlerta = false
        	this.cargar       = false
        	this.getVendedorasCRM( )
	      	// Agregarmos primero los datos
	      	
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      }
		},
	}
</script>
<style  scoped>


</style>
